export default "__VITE_ASSET__BRbEvm8Z__"